module.exports = function () {
    return function (input) {
        if (isNaN(input)) {
            input = 0;
        }
        return Math.floor(input).toFixed(0);
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/bws-dollars.js
 **/